"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _RowList = _interopRequireDefault(require("../../RowList"));

var _Label = _interopRequireDefault(require("../../Label"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var _SearchInput = _interopRequireDefault(require("../../SearchInput"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _InfiniteScroller = require("../../InfiniteScroller");

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var styles = function styles(theme) {
  return {
    BigMenu: {
      maxHeight: 500,
      overflow: 'hidden',
      background: theme['$extensible-dropdown-background'],
      borderRadius: 6,
      border: {
        width: 1,
        style: 'solid',
        color: theme['$menu-border-color']
      },
      boxShadow: {
        y: 2,
        blur: 0,
        color: theme['$shadow-color']
      },
      display: 'flex'
    },
    left: {
      width: 160,
      padding: 15,
      borderRight: '1px solid #ddd',
      '& > *': {
        width: 160
      }
    },
    right: {
      position: 'relative',
      width: 300,
      overflow: 'auto'
    },
    Loader: {
      padding: 130
    },
    List: {
      paddingTop: 41
    },
    Row: {
      padding: 10,
      height: 'auto'
    },
    Label: {
      display: 'flex',
      alignItems: 'center'
    },
    Checkbox: {
      marginTop: '0 !important',
      marginRight: '10px !important',
      cursor: 'pointer !important'
    },
    selected: {
      marginLeft: '15px !important'
    },
    selectAll: {
      position: 'fixed',
      width: 300,
      boxSizing: 'border-box',
      top: 1,
      right: 1,
      zIndex: 100,
      borderRadius: [0, 6, 0, 0]
    }
  };
};

var useStyles = (0, _ThemeProvider.createUseStyles)(styles);

var LoadingRow = function LoadingRow() {
  return /*#__PURE__*/_react["default"].createElement(_RowList["default"].Row, {
    key: "loading",
    "data-test-id": "loading-row",
    height: 48
  }, /*#__PURE__*/_react["default"].createElement(_RowList["default"].Column, null, /*#__PURE__*/_react["default"].createElement(_Loader["default"].TwinPulse, null)));
}; //eslint-disable-next-line


var Menu = function Menu(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      options = _ref.options,
      selected = _ref.selected,
      onItemClick = _ref.onItemClick,
      onFilterChange = _ref.onFilterChange,
      searchable = _ref.searchable,
      total = _ref.total,
      _ref$initialAllSelect = _ref.initialAllSelected,
      initialAllSelected = _ref$initialAllSelect === void 0 ? false : _ref$initialAllSelect,
      onSelectAll = _ref.onSelectAll,
      disableSelectAll = _ref.disableSelectAll,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      filterString = _ref.filterString,
      setLocalFilterString = _ref.setLocalFilterString,
      labels = _ref.labels,
      selectedText = _ref.selectedText,
      disableAllUnselected = _ref.disableAllUnselected,
      _ref$offsetBy = _ref.offsetBy,
      offsetBy = _ref$offsetBy === void 0 ? 100 : _ref$offsetBy,
      loadMore = _ref.loadMore,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "className", "children", "options", "selected", "onItemClick", "onFilterChange", "searchable", "total", "initialAllSelected", "onSelectAll", "disableSelectAll", "loading", "filterString", "setLocalFilterString", "labels", "selectedText", "disableAllUnselected", "offsetBy", "loadMore"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  var rowHeight = 40;

  var _useState = (0, _react.useState)(initialAllSelected),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      all = _useState2[0],
      selectAll = _useState2[1]; // if we have an external filter, call it


  var setFilterString = function setFilterString(event) {
    onFilterChange && onFilterChange(event.target.value);
    setLocalFilterString(event.target.value);
  };

  var clearFilter = function clearFilter() {
    onFilterChange && onFilterChange('');
    setLocalFilterString('');
  };

  var filteredOptions = onFilterChange ? options : options.filter(function (item) {
    return item.name.includes(filterString);
  });
  /*
          triggered if new options are presented in the list,
          for example if a new API call is made with new items.
          Then calculcates if the "Select all" checkbox should be ticked.
  */

  (0, _react.useEffect)(function () {
    var allAreSelected = filteredOptions.every(function (option) {
      return selected.includes(option.id);
    });
    selectAll(allAreSelected); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filteredOptions)]);

  var handleSelectAllClick = function handleSelectAllClick() {
    var newAll = !all;
    onSelectAll && onSelectAll(newAll);
    selectAll(newAll);
  };

  selectedText = selectedText || "".concat(selected.length, " of ").concat(total !== undefined ? total : options.length, " selected");

  var handleOnItemClick = function handleOnItemClick(id) {
    onItemClick && onItemClick(id);
    /*
        calculate if user have now selected or unselected the last checkbox in the list and
        the "Select all" checkbox should now be toggled.
    */

    var newSelected = selected.includes(id) ? selected.filter(function (item) {
      return item !== id;
    }) : [].concat((0, _toConsumableArray2["default"])(selected), [id]);
    var allAreSelected = filteredOptions.every(function (option) {
      return newSelected.includes(option.id);
    });
    selectAll(allAreSelected);
  };

  var onRowClick = function onRowClick(item) {
    return !(!selected.includes(item.id) && disableAllUnselected) && handleOnItemClick(item.id);
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, classes.BigMenu),
    id: id
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, searchable && /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
    id: "".concat(id, "-SEARCH-INPUT"),
    "data-test-id": "".concat(id, "-SEARCH-INPUT"),
    placeholder: labels.searchInput,
    value: filterString,
    onChange: function onChange(e) {
      return setFilterString(e);
    },
    clearInput: clearFilter
  }), children), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.right
  }, loading && !options.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Loader
  }, /*#__PURE__*/_react["default"].createElement(_Loader["default"].Ripple, {
    height: 40,
    width: 40
  })) :
  /*
      if no options, then render a rowlist with only "Select all" checkbox without InfiniteScroller,
      cause if no items then the InfiniteScroller will render nothing.
  */
  filteredOptions.length ? /*#__PURE__*/_react["default"].createElement(_InfiniteScroller.InfiniteScroller, {
    listData: filteredOptions,
    refreshToken: filteredOptions.length,
    offsetBy: offsetBy,
    loadMore: loadMore || function () {
      return;
    },
    totalCount: total !== undefined ? total : options.length,
    itemHeight: rowHeight,
    render: function render(_ref2) {
      var virtual = _ref2.virtual,
          itemHeight = _ref2.itemHeight;
      return /*#__PURE__*/_react["default"].createElement(_RowList["default"], {
        className: classes.List,
        style: virtual.style
      }, /*#__PURE__*/_react["default"].createElement(_RowList["default"].Row, {
        isEven: false,
        key: "___select-all",
        className: "".concat(classes.selectAll, " ").concat(classes.Row),
        style: {
          height: itemHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_RowList["default"].Column, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        id: "".concat(id, "-SELECT-ALL"),
        "data-test-id": "".concat(id, "-SELECT-ALL"),
        className: classes.Checkbox,
        checked: all,
        disabled: disableSelectAll,
        onClick: handleSelectAllClick
      })), /*#__PURE__*/_react["default"].createElement(_RowList["default"].Column, null, /*#__PURE__*/_react["default"].createElement("label", {
        style: {
          display: 'inline'
        }
      }, labels.selectAll), /*#__PURE__*/_react["default"].createElement("strong", {
        className: classes.selected
      }, selectedText))), /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": "".concat(id, "-OPTIONS-LIST"),
        style: {
          marginTop: "".concat(rowHeight, "px")
        }
      }, virtual.items.map(function (item) {
        if (item.loading) {
          return /*#__PURE__*/_react["default"].createElement(LoadingRow, {
            key: item.itemIndex
          });
        } else {
          return /*#__PURE__*/_react["default"].createElement(_RowList["default"].Row, {
            onClick: function onClick() {
              return onRowClick(item);
            },
            key: item.id,
            isEven: item.itemIndex % 2 == 1,
            className: classes.Row,
            style: {
              height: itemHeight
            }
          }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
            className: classes.Label
          }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            id: "select-".concat(item.id),
            "data-test-id": "select-".concat(item.id),
            className: classes.Checkbox,
            disabled: !selected.includes(item.id) && disableAllUnselected,
            checked: selected.includes(item.id)
          }), item.name));
        }
      })));
    }
  }) : /*#__PURE__*/_react["default"].createElement(_RowList["default"], {
    className: classes.List
  }, /*#__PURE__*/_react["default"].createElement(_RowList["default"].Row, {
    isEven: false,
    key: "___select-all",
    className: "".concat(classes.selectAll, " ").concat(classes.Row)
  }, /*#__PURE__*/_react["default"].createElement(_RowList["default"].Column, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    id: "".concat(id, "-SELECT-ALL"),
    "data-test-id": "".concat(id, "-SELECT-ALL"),
    className: classes.Checkbox,
    checked: all,
    disabled: disableSelectAll,
    onClick: handleSelectAllClick
  })), /*#__PURE__*/_react["default"].createElement(_RowList["default"].Column, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      display: 'inline'
    }
  }, labels.selectAll), /*#__PURE__*/_react["default"].createElement("strong", {
    className: classes.selected
  }, selectedText))))));
};

exports.Menu = exports["default"] = Menu;
//# sourceMappingURL=index.js.map